import { default as addressDetails } from './addressDetails';
import countryOfOrigin from './countryOfOrigin';
import obfuscation from './obfuscation';
import details from './details';
import onCheckoutOwnerLastNameChange from './onCheckoutOwnerLastNameChange';
import onCheckoutOwnerNameChange from './onCheckoutOwnerNameChange';
import childrenDetails from './childrenDetails';

export const owner = {
  ...childrenDetails,
  ...addressDetails,
  ...countryOfOrigin,
  ...obfuscation,
  ...details,
  ...onCheckoutOwnerLastNameChange,
  ...onCheckoutOwnerNameChange,
};
